export interface Game {
  id: string;
  name: string;
  category: string;
  categoryName: string;
  image: string;
  description: string;
  rating: number;
  players: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { id: 'all', name: '全部游戏', icon: 'ri-gamepad-line' },
  { id: 'board', name: '棋牌游戏', icon: 'ri-vip-crown-line' },
  { id: 'slots', name: '电子游艺', icon: 'ri-flashlight-line' },
  { id: 'fishing', name: '捕鱼游戏', icon: 'ri-anchor-line' },
  { id: 'sports', name: '体育竞猜', icon: 'ri-football-line' },
  { id: 'live', name: '真人视讯', icon: 'ri-live-line' },
];

export const games: Game[] = [
  {
    id: 'game-1',
    name: '龙虎斗',
    category: 'live',
    categoryName: '真人视讯',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20casino%20live%20dealer%20studio%20with%20golden%20dragon%20and%20tiger%20theme%2C%20warm%20lighting%2C%20professional%20dealer%20table%20with%20red%20and%20gold%20accents%2C%20luxurious%20atmosphere%2C%20cinematic%20lighting%2C%20clean%20composition&width=800&height=600&seq=game-dragon-tiger&orientation=landscape',
    description: '经典龙虎对决，真人荷官发牌，体验最纯正的博彩乐趣。实时高清画面，多种投注选择。',
    rating: 4.8,
    players: '128.5万',
    tags: ['真人', '热门', '经典'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'game-2',
    name: '幸运777',
    category: 'slots',
    categoryName: '电子游艺',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20slot%20machine%20with%20golden%20number%20777%20theme%2C%20colorful%20fruits%20and%20gems%2C%20bright%20neon%20lights%2C%20casino%20atmosphere%2C%20clean%20minimal%20background%2C%20glowing%20effects%2C%20exciting%20gaming%20vibe&width=800&height=600&seq=game-lucky-777&orientation=landscape',
    description: '经典777老虎机，超高爆率，丰厚大奖等你来拿。多线投注，免费旋转，奖金翻倍。',
    rating: 4.9,
    players: '256.3万',
    tags: ['老虎机', '高爆率', '大奖'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'game-3',
    name: '深海捕鱼',
    category: 'fishing',
    categoryName: '捕鱼游戏',
    image: 'https://readdy.ai/api/search-image?query=Underwater%20ocean%20scene%20with%20colorful%20tropical%20fish%2C%20treasure%20chests%20on%20seabed%2C%20coral%20reef%2C%20crystal%20clear%20blue%20water%2C%20game%20style%20art%2C%20vibrant%20colors%2C%20dynamic%20composition%2C%20clean%20background&width=800&height=600&seq=game-deep-sea-fishing&orientation=landscape',
    description: '沉浸式深海捕鱼体验，绚丽画面，百种鱼类。炮台升级，BOSS挑战，金币爆不停。',
    rating: 4.7,
    players: '189.2万',
    tags: ['捕鱼', '休闲', '多人'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'game-4',
    name: '世界杯竞猜',
    category: 'sports',
    categoryName: '体育竞猜',
    image: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20stadium%20atmosphere%20with%20golden%20trophy%2C%20green%20pitch%2C%20dramatic%20stadium%20lights%2C%20sports%20betting%20theme%2C%20dynamic%20energy%2C%20clean%20minimal%20composition%2C%20warm%20golden%20accents&width=800&height=600&seq=game-world-cup-betting&orientation=landscape',
    description: '全球顶级赛事竞猜，足球、篮球、网球全覆盖。实时赔率更新，多种玩法任你选。',
    rating: 4.6,
    players: '312.7万',
    tags: ['体育', '竞猜', '直播'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'game-5',
    name: '百人牛牛',
    category: 'board',
    categoryName: '棋牌游戏',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20card%20game%20table%20with%20red%20felt%20surface%2C%20playing%20cards%20scattered%2C%20golden%20decorations%2C%20warm%20ambient%20lighting%2C%20luxurious%20gaming%20room%2C%20clean%20composition%2C%20traditional%20Chinese%20aesthetics&width=800&height=600&seq=game-bull-fight&orientation=landscape',
    description: '百人同场竞技，经典牛牛玩法，紧张刺激。多种房型选择，公平公正，实时对战。',
    rating: 4.8,
    players: '201.4万',
    tags: ['棋牌', '多人', '经典'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'game-6',
    name: '星月神话',
    category: 'slots',
    categoryName: '电子游艺',
    image: 'https://readdy.ai/api/search-image?query=Magical%20night%20sky%20with%20stars%20and%20crescent%20moon%2C%20mythical%20atmosphere%2C%20golden%20sparkles%2C%20fantasy%20theme%20slot%20game%2C%20deep%20blue%20and%20gold%20color%20scheme%2C%20clean%20composition%2C%20dreamy%20aesthetic&width=800&height=600&seq=game-star-moon-myth&orientation=landscape',
    description: '梦幻星空主题老虎机，精美画面，多重奖励机制。免费游戏、奖金翻倍、累积大奖。',
    rating: 4.7,
    players: '98.6万',
    tags: ['老虎机', '新游', '高颜值'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'game-7',
    name: '百家乐豪华版',
    category: 'live',
    categoryName: '真人视讯',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20baccarat%20table%20with%20professional%20dealer%2C%20elegant%20casino%20setting%2C%20crystal%20chandeliers%2C%20green%20felt%20table%2C%20golden%20chips%2C%20warm%20sophisticated%20lighting%2C%20clean%20composition%2C%20high-end%20atmosphere&width=800&height=600&seq=game-baccarat-deluxe&orientation=landscape',
    description: '顶级真人百家乐，多角度高清直播。专业荷官，流畅发牌，沉浸式娱乐体验。',
    rating: 4.9,
    players: '345.1万',
    tags: ['真人', '热门', 'VIP'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'game-8',
    name: '金蟾捕鱼',
    category: 'fishing',
    categoryName: '捕鱼游戏',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythical%20golden%20toad%20in%20underwater%20scene%2C%20coins%20and%20treasures%2C%20colorful%20fish%20swimming%2C%20traditional%20Chinese%20auspicious%20theme%2C%20vibrant%20red%20and%20gold%20colors%2C%20game%20art%20style%2C%20clean%20composition&width=800&height=600&seq=game-golden-toad-fishing&orientation=landscape',
    description: '金蟾招财主题捕鱼，财源滚滚，好运连连。特色技能，全屏炸弹，金币爆满屏。',
    rating: 4.6,
    players: '156.8万',
    tags: ['捕鱼', '招财', '休闲'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'game-9',
    name: '德州扑克大师',
    category: 'board',
    categoryName: '棋牌游戏',
    image: 'https://readdy.ai/api/search-image?query=Professional%20poker%20table%20with%20cards%20and%20chips%2C%20green%20felt%20surface%2C%20golden%20accents%2C%20dramatic%20overhead%20lighting%2C%20competitive%20atmosphere%2C%20clean%20composition%2C%20high-stakes%20vibe&width=800&height=600&seq=game-texas-poker-master&orientation=landscape',
    description: '国际标准德州扑克，全球玩家实时对战。多种赛事，丰厚奖池，挑战最强牌手。',
    rating: 4.8,
    players: '178.3万',
    tags: ['棋牌', '竞技', '赛事'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'game-10',
    name: '电竞LOL竞猜',
    category: 'sports',
    categoryName: '体育竞猜',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20esports%20arena%20with%20glowing%20screens%2C%20League%20of%20Legends%20theme%2C%20blue%20and%20gold%20neon%20lights%2C%20competitive%20gaming%20atmosphere%2C%20dynamic%20energy%2C%20clean%20composition%2C%20modern%20esports%20vibe&width=800&height=600&seq=game-esports-lol&orientation=landscape',
    description: '英雄联盟等顶级电竞赛事竞猜，实时数据，专业分析。赛事丰富，赔率最优。',
    rating: 4.5,
    players: '223.6万',
    tags: ['电竞', '竞猜', '新潮'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'game-11',
    name: '财神到',
    category: 'slots',
    categoryName: '电子游艺',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20God%20of%20Wealth%20theme%20slot%20machine%2C%20golden%20ingots%20and%20red%20envelopes%2C%20festive%20Chinese%20New%20Year%20atmosphere%2C%20bright%20red%20and%20gold%20colors%2C%20auspicious%20symbols%2C%20clean%20composition%2C%20celebratory%20vibe&width=800&height=600&seq=game-god-of-wealth&orientation=landscape',
    description: '财神主题老虎机，福气满满，大奖不断。红包雨、金元宝、免费旋转等丰富玩法。',
    rating: 4.8,
    players: '289.4万',
    tags: ['老虎机', '热门', '中国风'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'game-12',
    name: '21点高手',
    category: 'live',
    categoryName: '真人视讯',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20blackjack%20table%20with%20professional%20female%20dealer%2C%20playing%20cards%20and%20chips%2C%20luxurious%20casino%20interior%2C%20warm%20ambient%20lighting%2C%20sophisticated%20atmosphere%2C%20clean%20composition%2C%20high-end%20gaming&width=800&height=600&seq=game-blackjack-pro&orientation=landscape',
    description: '真人21点，策略与运气的完美结合。多台同开，自由切换，随时随地畅玩。',
    rating: 4.7,
    players: '167.2万',
    tags: ['真人', '策略', '经典'],
    isHot: false,
    isNew: false,
  },
];